module.exports = __webpack_public_path__ + "static/media/AppLiftInPhone.52fad9ca.png";